<template>
  <div style="position:relative;">
    <div class="c-share">
      <input id="checkbox" ref="checkbox" class="c-share__input" type="checkbox">
      <label class="c-share__toggler" for="checkbox">
        <i class="uil-plus"></i>
      </label>

      <ul :data-title="$t('general.create_fast')" class="c-share_options">
        <li>
          <router-link :to="{ name: 'company.question.add' }"> {{ $t('general.add_question') }}</router-link>
        </li>
        <!-- <li>
          <router-link :to="{ name: 'company.institutions.add' }">Kurum Ekle</router-link>
        </li> -->
        <!-- <li>
          <router-link :to="{ name: 'company.companies.add' }">Firma Ekle</router-link>
        </li> -->
        <li>
          <router-link :to="{ name: 'company.user.add' }"> {{ $t('general.add_users') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.content.add' }"> {{ $t('general.add_content') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.program.add' }"> {{ $t('general.add_program') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.assignments.add' }"> {{ $t('general.assign') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.content.catalog.add' }"> {{ $t('general.add_catalog_education') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.survey.add' }"> {{ $t('general.add_survey') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.certificate.add' }"> {{ $t('certificate.add') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.certificate_template.add' }">{{
              $t('certificate_template.add')
            }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.advertisement.add' }"> {{ $t('general.add_ads') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'company.announcement.add' }"> {{ $t('general.create_announcement') }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickShare",
  methods: {
    toggle() {
      let el = this.$refs.checkbox
      el.checked = false
    }
  },
  watch: {
    $route() {
      this.toggle();
    }
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .c-share {
    right: 0 !important;
  }
}

.c-share {
  position: fixed;
  max-width: inherit;
  bottom: 50%;
  width: 3.4375em;
  height: 3.4375em;
  z-index: 10000;
  position: fixed;
  right: 47px;
  opacity: 1;
  bottom: 35px;
  margin: 0 32px 0 0;
  -webkit-transition: 0.35s;
  transition: 0.35s;
  -webkit-transform: translateY(10px);
  transform: translateY(10px);
}

.c-share__input {
  display: none;
}

.c-share__input:checked ~ .c-share__toggler .c-share__icon {
  transition: 0s;
  width: 0;
  height: 0;
  color: #639eff;
}

.c-share__input:checked ~ .c-share__toggler .c-share__icon::before {
  transform: rotate(-45deg);
}

.c-share__input:checked ~ .c-share__toggler .c-share__icon::after {
  transform: rotate(45deg);
}

.c-share__input:checked ~ .c-share_options {
  width: 15.0625em;
  height: auto;
  border-radius: 0.3125em;
  bottom: 0;
}

.c-share_options li:hover {
  color: #000;
  font-weight: 500;
}

.c-share__input:checked ~ .c-share_options::before,
.c-share__input:checked ~ .c-share_options li {
  transition: 0.3s 0.15s;
  opacity: 1;
  transform: translateY(0);
  font-size: 13px;
}

.c-share__toggler,
.c-share_options {
  position: absolute;
  right: 0;
  width: inherit;
  height: inherit;
  border-radius: 50%;
  background-color: #f2f2f2;
}

.c-share__toggler {
  cursor: pointer;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-share__icon {
  position: relative;
  left: -0.3125em;
  width: 0.5em;
  height: 0.5em;
  border-radius: 50%;
  color: #029dfc;
  background-color: currentColor;
  box-shadow: 0.625em -0.625em, 0.625em 0.625em;
  transition: 0.1s 0.05s;
}

.c-share__icon::before,
.c-share__icon::after {
  content: "";
  position: absolute;
  width: 1em;
  height: 0.125em;
  background-color: currentColor;
  transition: 0.1s;
}

.c-share__icon::before {
  top: 0.1875em;
  left: 0.1875em;
  transform-origin: bottom left;
  transform: rotate(45deg);
}

.c-share__icon::after {
  top: -0.125em;
  left: 0.03125em;
  transform-origin: center;
  transform: rotate(-45deg);
}

.c-share_options {
  list-style: none;
  margin: 0;
  padding: 1.0625em 1.25em !important;
  box-sizing: border-box;
  overflow: hidden;
  transition: 0.2s;
  box-shadow: 0 0.125em 0.125em rgba(0, 0, 0, 0.3);
}

.c-share_options::before {
  content: attr(data-title);
  display: block;
  margin-bottom: 1.25em;
  font-weight: 700;
}

.c-share_options li {
  font-size: 0.875em;
  color: #464646;
  cursor: pointer;
}

.c-share_options li:not(:last-child) {
  margin-bottom: 0.75em;
}

.c-share_options::before,
.c-share_options li {
  opacity: 0;
  transform: translateY(0.625em);
  transition: 0s;
}
</style>
